import React, { Component } from 'react';
import { Motion, spring, presets } from 'react-motion';

export default class ErrorsConnection extends Component {
  constructor(props) {
    super(props);
  }

  getErrorItem (error, index) {
    return (<li key={index}>{error}</li>);
  }

  getErrorsBlock (errors, options = { type: 'error' }) {
    errors = typeof errors === 'string' ? [errors] : errors;
    if ( !errors || typeof errors === 'object' && !Object.keys(errors).length ) {
      return null;
    }

    if (!Array.isArray(errors)) {
      return null;
    }

    errors = errors.filter(e => e);

    if (!errors.length) {
      return null;
    }

    // let errorsDOM = errors.map((error, index) => {
    //   return this.getErrorItem(error, index);
    // });
    const { type } = options;
    const errorsDOM = this.getErrorItem(errors[0], 0);

    return (
      <Motion defaultStyle={{ opacity: 0.5 }} style={{ opacity: spring(1, presets.stiff) }}>
        {
          config =>
            <ul style={{ opacity: config.opacity }} className={`errorlist ${type}`}>{errorsDOM}</ul>
        }
      </Motion>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/views/ErrorsHigherOrderComponent.js